import { useEffect, useState } from 'react';

export const useCountdown = (initialTime, resetTrigger, onTick = null) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (initialTime !== timeLeft) {
      setTimeLeft(initialTime);
    }
  }, [initialTime, resetTrigger]);

  useEffect(() => {
    if ([undefined, 0].includes(timeLeft)) return;

    const timerId = setInterval(() => {
      setTimeLeft(prevTimeLeft => {
        const newTimeLeft = prevTimeLeft - 1;
        if (onTick) {
          onTick(newTimeLeft);
        }
        return newTimeLeft;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft, onTick]);

  return [timeLeft];
};
